
import Vue from 'vue';

import Index from './components/Index.vue';



import MainDetail from './components/MainDetail.vue';
import OprationData from './components/OprationData.vue';

import Router from 'vue-router';
Vue.use(Router);

import axios from '@/assets/js/comaxios.js';
Vue.prototype.$ajax = axios;

var router = new Router({
routes: [
{
path: '/',
component: Index
},
{
path: '/index',
name: 'Index',
component: Index
},
{
path: '/goldbuy',
name: 'Index',
component: Index
},
{
path: '/blackcheck',
name: 'Index',
component: Index
},
{
path: '/maindetail',
name: 'MainDetail',
component: MainDetail
},
{
path: '/oprationdata',
name: 'OprationData',
component: OprationData
},
]
})

import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin);

import { Navbar, TabItem,TabContainer,TabContainerItem,Lazyload } from 'mint-ui';
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.use(Lazyload);

export default {
name: 'app',
router,
components: {


},
methods: {
},
}
